import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';

import smallcapsIcon from './icons/smallcaps.svg';
import { SMALLCAPS } from './smallcapsediting';

/**
 * The Smallcaps UI feature. It introduces the Smallcaps button.
 */
export default class SmallcapsUI extends Plugin {
  init() {
    const editor = this.editor;
    const t = editor.t;

    // Add smallcaps button to feature components.
    editor.ui.componentFactory.add(SMALLCAPS, locale => {
      const command = editor.commands.get(SMALLCAPS);
      const view = new ButtonView(locale);

      view.set({
        label: t('Smallcaps'),
        icon: smallcapsIcon,
        tooltip: true
      });

      view.bind('isOn', 'isEnabled').to(command, 'value', 'isEnabled');

      // Execute command with focus on the document 
      this.listenTo(view, 'execute', () => {
        editor.focus();
        editor.execute(SMALLCAPS);
      });

      return view;
    });
  }
}
